import useLibraryDocuments from '../../hooks/useLibraryDocuments'
import { useMemo } from 'react'
import { ILibraryDocument } from '../../libraryDocuments.types'
import SearchDropdownInput from '@/shared/Inputs/SearchDropdownInput'

interface IProps {
  name: string
  onChange: (val: string, name: string) => void
  value: ILibraryDocument['id']
  title?: string
}

const SVGDocumentDropdown = (props: IProps) => {
  const { libraryDocumentsState, loading: documentsLoading } = useLibraryDocuments()
  const documents = libraryDocumentsState.items

  const svgDocumentsOptions = useMemo(() => {
    return documents.filter((d) => d.extension === 'svg').map((o) => ({ title: o.fileName, value: o.id }))
  }, [documents])

  return (
    <SearchDropdownInput
      options={svgDocumentsOptions}
      onSelect={props.onChange}
      selectedOption={props.value as any}
      title={props.title}
      name={props.name}
      disabled={documentsLoading}
    />
  )
}

export default SVGDocumentDropdown
